interface SplitKeyInterface {
  primaryBusinessId?: string;
  deploymentId?: number;
  saleLotId?: string;
  consignmentId?: string;
  livestockSaleId?: number;
}

export interface SplitLookup {
  [id: string]: VendorSplit | BuyerSplit;
}

export const getSplitKey = ({
  primaryBusinessId,
  deploymentId,
  saleLotId,
  consignmentId,
  livestockSaleId,
}: SplitKeyInterface): string =>
  [
    primaryBusinessId,
    deploymentId,
    saleLotId || consignmentId || livestockSaleId,
  ].join("|");

interface BestMatchingSplitInterface {
  splitByKeyLookup: SplitLookup;
  primaryBusinessId: string;
  deploymentId: number;
  livestockSaleId: number;
  consignmentId: string;
  saleLotId: string;
}

export const getBestMatchingSplit = ({
  splitByKeyLookup,
  primaryBusinessId,
  deploymentId,
  livestockSaleId,
  consignmentId,
  saleLotId,
}: BestMatchingSplitInterface) => {
  // Return the best matching split using the available inputs.

  if (!splitByKeyLookup) {
    return null;
  }

  const saleLotSplitKey = getSplitKey({
    primaryBusinessId,
    deploymentId,
    saleLotId,
  });

  const consignmentSplitKey = getSplitKey({
    primaryBusinessId,
    deploymentId,
    consignmentId,
  });

  const saleSplitKey = getSplitKey({
    primaryBusinessId,
    deploymentId,
    livestockSaleId,
  });

  return (
    splitByKeyLookup[saleLotSplitKey] ||
    splitByKeyLookup[consignmentSplitKey] ||
    splitByKeyLookup[saleSplitKey]
  );
};
